import { createContext, useContext, useEffect, useState } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const raw = localStorage.getItem("brf_user");
    if (raw) {
      try { setUser(JSON.parse(raw)); } catch (e) {}
    }
    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.removeItem("brf_token");
    localStorage.removeItem("brf_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
